import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Divider,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const PermisosWebList = ({ permisos, onPermisosChange }) => {
  const [expanded, setExpanded] = useState(null);
  const [permisosState, setPermisosState] = useState([]);

  useEffect(() => {
    setPermisosState(permisos);
  }, [permisos]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleChangeCheck = (idPermisoWeb) => (event) => {
    const { checked } = event.target;

    const updatePermisos = (permisos) => {
      return permisos.map((permiso) => {
        if (permiso.idPermisoWeb === idPermisoWeb) {
          return { ...permiso, estatus: checked };
        } else if (permiso.inverseIdPermisoPadreNavigation.length > 0) {
          return {
            ...permiso,
            inverseIdPermisoPadreNavigation: updatePermisos(
              permiso.inverseIdPermisoPadreNavigation
            ),
          };
        }
        return permiso;
      });
    };

    const updatedPermisos = updatePermisos(permisosState);
    setPermisosState(updatedPermisos);
    onPermisosChange(updatedPermisos);
  };

  const renderPermiso = (permiso) => {
    return (
      <Accordion
        key={permiso.idPermisoWeb}
        expanded={expanded === `panel-${permiso.idPermisoWeb}`}
        onChange={handleChange(`panel-${permiso.idPermisoWeb}`)}
        sx={{
          overflow: "hidden",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: 2,
          width: "100%",
          margin: "auto",
          maxWidth: "100%",
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <FormControlLabel
            control={
              <Checkbox
                checked={permiso.estatus}
                onChange={handleChangeCheck(permiso.idPermisoWeb)}
                name={`checkbox-${permiso.idPermisoWeb}`}
              />
            }
            label={permiso.descripcion}
          />
        </AccordionSummary>
        <AccordionDetails>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {permiso.inverseIdPermisoPadreNavigation.length > 0 &&
              permiso.inverseIdPermisoPadreNavigation.map((hijo) => (
                <Accordion
                  key={hijo.idPermisoWeb}
                  sx={{
                    width: "100%",
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={hijo.estatus}
                          onChange={handleChangeCheck(hijo.idPermisoWeb)}
                          name={`checkbox-${hijo.idPermisoWeb}`}
                        />
                      }
                      label={hijo.descripcion}
                    />
                  </AccordionSummary>
                  <AccordionDetails>
                    <List style={{ width: "100%" }}>
                      {hijo.inverseIdPermisoPadreNavigation &&
                        hijo.inverseIdPermisoPadreNavigation.map(
                          (nieto, index) => (
                            <React.Fragment key={nieto.idPermisoWeb}>
                              <ListItem>
                                <Checkbox
                                  checked={nieto.estatus}
                                  onChange={handleChangeCheck(
                                    nieto.idPermisoWeb
                                  )}
                                  name={`checkbox-${nieto.idPermisoWeb}`}
                                />
                                <ListItemText
                                  primary={nieto.descripcionAccion}
                                />
                              </ListItem>
                              {index !==
                                hijo.inverseIdPermisoPadreNavigation.length -
                                  1 && <Divider />}
                            </React.Fragment>
                          )
                        )}
                    </List>
                  </AccordionDetails>
                </Accordion>
              ))}
          </div>
        </AccordionDetails>
      </Accordion>
    );
  };

  return <div>{permisosState.map((permiso) => renderPermiso(permiso))}</div>;
};

export default PermisosWebList;
